import type { RequestStatus } from 'features/request/requestSlice';
import type { UercCalculationSeasonData } from 'gql/graphql';

import { useMemo } from 'react';

import { useBimcCalculationSeasons } from '../../hooks/useUercCalculationSeasons';

export const useBimCalculationSeasons = (
    calculationId: number | undefined,
    withEffect = true,
): [UercCalculationSeasonData[], RequestStatus, any] => {
    const [bimcSeasons, status, error] = useBimcCalculationSeasons(calculationId, withEffect);

    const seasons = useMemo(
        () =>
            [...bimcSeasons]
                .sort((a, b) => a.year - b.year)
                .map(({ id, year }) => ({ seasonId: id, year }) as UercCalculationSeasonData),
        [bimcSeasons],
    );

    return [seasons, status, error];
};
